function addonItems() {

  (() => {
  const html = document.documentElement;
  const qs  = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function trapTab(e, modal) {
    const focusables = modal.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];
    if (e.key === 'Tab') {
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function wireCloseHandlers(modal) {
    if (modal._wired) return;
    modal._wired = true;
    modal.querySelectorAll('[data-modal-close], .wt-modal__overlay, .wt-modal__close')
      .forEach(el => el.addEventListener('click', (ev) => { ev.preventDefault(); closeModal(modal); }));
  }

  function openModal(modal) {
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    wireCloseHandlers(modal);
    qsa('.wt-modal[data-open="true"]').forEach(m => closeModal(m));
    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    html.style.overflow = 'hidden';
    modal._lastFocus = document.activeElement;
    const firstFocusable = modal.querySelector('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])') || modal;
    firstFocusable.focus();
    modal._keyHandler = (e) => {
      if (e.key === 'Escape') closeModal(modal);
      trapTab(e, modal);
    };
    document.addEventListener('keydown', modal._keyHandler);
  }

  function closeModal(modal) {
    modal.removeAttribute('data-open');
    modal.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', modal._keyHandler);
    html.style.overflow = '';
    if (modal._lastFocus && typeof modal._lastFocus.focus === 'function') modal._lastFocus.focus();
  }

  window.WT_openShoppableModal = (trigger) => {
    const id = trigger?.getAttribute?.('data-modal-target');
    if (!id) return;
    const modal = document.getElementById(id);
    if (!modal) return;
    openModal(modal);
  };
  // Helper: Firefox sometimes uses text nodes as event targets (no .closest)
  // Robust helper: works with text nodes, Safari, Firefox, etc.
  function getClosest(target, selector) {
    let el = target;

    while (el && el !== document && el !== window) {
      // nodeType 1 = Element
      if (el.nodeType === 1 && el.matches(selector)) {
        return el;
      }
      el = el.parentNode;
    }

    return null;
  }


  // Open modal on click/keyboard
    // Open modal on click
    document.addEventListener('click', (ev) => {
      const trigger = getClosest(ev.target, '[data-modal-target]');
      if (!trigger) return;
      ev.preventDefault();
      WT_openShoppableModal(trigger);
    });
  document.addEventListener('keydown', (ev) => {
    const trigger = getClosest(ev.target, '[data-modal-target]');
    if ((ev.key === 'Enter' || ev.key === ' ') && trigger) {
      ev.preventDefault();
      WT_openShoppableModal(trigger);
    }
  });


  /* Add to cart */
  async function addToCart(variantId, quantity) {
    const sectionsToUpdate = ['cart-drawer','cart-icon-bubble','cart-live-region-text'];
    const endpoint =
      (window.routes && window.routes.cart_add_url) ||
      (window.Shopify && Shopify.routes && Shopify.routes.cart_add_url) ||
      '/cart/add.js';

    const postJSON = async () => {
      const res = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }], sections: sectionsToUpdate, sections_url: window.location.pathname })
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json?.status === 422) throw new Error(json?.description || 'Unable to add');
      return json;
    };

    const postForm = async () => {
      const fd = new FormData();
      fd.append('id', String(variantId));
      fd.append('quantity', String(quantity));
      const res = await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json?.status === 422) throw new Error(json?.description || 'Unable to add');
      return json;
    };

    try { return await postJSON(); } catch { return await postForm(); }
  }

  function refreshSections(data) {
    if (!data?.sections) return;
    
    // Сохраняем состояние collapsed перед обновлением
    const drawer = document.querySelector('cart-drawer-section') || document.querySelector('cart-drawer');
    const crossSell = drawer?.querySelector('.wt-cart__cross-sell');
    const wasCollapsed = crossSell?.classList.contains('wt-cart__cross-sell--collapsed') || false;
    if (wasCollapsed) {
      sessionStorage.setItem('wt-cross-sell-collapsed', 'true');
    } else {
      sessionStorage.removeItem('wt-cross-sell-collapsed');
    }
    
    Object.entries(data.sections).forEach(([id, html]) => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = html;
    });
    
    // Восстанавливаем состояние collapsed сразу после обновления DOM
    if (wasCollapsed) {
      const newDrawer = document.querySelector('cart-drawer-section') || document.querySelector('cart-drawer');
      const newCrossSell = newDrawer?.querySelector('.wt-cart__cross-sell');
      if (newCrossSell) {
        newCrossSell.classList.add('wt-cart__cross-sell--collapsed');
        // Пересчитываем высоту после восстановления состояния
        if (window.__crossSellRecalc) {
          requestAnimationFrame(() => {
            window.__crossSellRecalc(newCrossSell);
          });
        }
      }
    }
    
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { detail: { open: true } }));
    if (drawer) {
      drawer.classList?.remove('is-empty');
      drawer?.open?.();
    }
  }

    document.addEventListener('click', (ev) => {
  const trigger = getClosest(ev.target, '[data-modal-target]');
  if (!trigger) return;
  ev.preventDefault();
  WT_openShoppableModal(trigger);
});

document.addEventListener('keydown', (ev) => {
  const trigger = getClosest(ev.target, '[data-modal-target]');
  if ((ev.key === 'Enter' || ev.key === ' ') && trigger) {
    ev.preventDefault();
    WT_openShoppableModal(trigger);
  }
});

document.addEventListener('click', async (ev) => {
  const btn = getClosest(ev.target, '.wt-add');
  if (!btn) return;

  ev.preventDefault();
  if (btn.disabled) return;

  const variantId = btn.getAttribute('data-variant-id');
  const qty = parseInt(btn.getAttribute('data-quantity') || '1', 10);
  if (!variantId) {
    console.warn('Missing data-variant-id');
    return;
  }

  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  try {
    const data = await addToCart(variantId, qty);
    const modal = btn.closest('.wt-modal'); // this is fine, btn is definitely an Element
    if (modal?.getAttribute('data-open') === 'true') closeModal(modal);
    refreshSections(data);
    btn.textContent = 'Added ✓';
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'))
  } catch (err) {
    console.error(err);
    btn.textContent = 'Error – try again';
  } finally {
    setTimeout(() => {
      btn.textContent = original;
      btn.disabled = false;
    }, 1400);
  }
});


})();
  
}

class CartDrawerSection extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  constructor() {
    super();    

    this.cartType = this.dataset.cartType;
    this.drawerClass = "wt-cart__drawer";
    this.drawer = this.querySelector(`.${this.drawerClass}`);
    this.classDrawerActive = `${this.drawerClass}--open`;
    this.pageOverlayClass = "page-overlay-cart";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;
    this.triggerQuery = [
      `.wt-cart__trigger`,
      `.wt-cart__back-link`,
      `.${this.pageOverlayClass}`,
    ].join(", ");
    this.triggers = () => document.querySelectorAll(this.triggerQuery);
    this.isOpen = false;
    this.isCartPage = window.location.pathname === window.routes.cart_url;
    this.closeButton = () => this.querySelector(".wt-cart__drawer__close");
    this.mainTrigger = document.querySelector(".wt-cart__trigger");
    this.toggleEelements = () =>
      this.querySelectorAll(this.dataset.toggleTabindex);
  }

  connectedCallback() {
    if (this.cartType === "page" || this.isCartPage) {
      document.addEventListener('cart-drawer:refresh', (e) => this.refreshCartDrawer(e))
      return;
    }

    this.init();
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (this.isOpen) {
        setTabindex(this.toggleEelements(), "0");
        this.closeButton().focus();
      }
    });    
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  getFocusableElements() {
    const focusableElementsSelector =
      "button, [href], input, select, [tabindex]";
    const focusableElements = () =>
      Array.from(this.querySelectorAll(focusableElementsSelector)).filter(
        (el) => !el.hasAttribute("disabled") && el.tabIndex >= 0,
      );

    return {
      focusableElements,
      first: focusableElements()[0],
      last: focusableElements()[focusableElements().length - 1],
    };
  }

  temporaryHideFocusVisible() {
    document.body.classList.add("no-focus-visible");
  }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      this.isOpen = false;
      this.mainTrigger.focus();
      this.temporaryHideFocusVisible();
      setTabindex(this.toggleEelements(), "-1");
    } else {
      this.setAttribute("open", "");
      this.isOpen = true;
      this.closeButton().focus();
      this.temporaryHideFocusVisible();
      setTabindex(this.toggleEelements(), "0");
    }
  }

  toggleDrawerClasses() {
    addonItems();    
    this.onToggle();
    this.drawer.classList.toggle(this.classDrawerActive);
    this.body.classList.toggle(this.activeOverlayBodyClass);
  }

  init() {
    this.addEventListener("keydown", (e) => {
      const isTabPressed =
        e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const { first, last } = this.getFocusableElements();

      if (e.key === "Escape" || e.keyCode === 27 || e.code === "Escape") {
        if (this.isOpen) {
          this.toggleDrawerClasses();
        }
      }

      if (isTabPressed) {
        if (e.shiftKey && document.activeElement === first) {
          last.focus();
          e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    });

    this.triggers().forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleDrawerClasses();
      });
    });

    this.addEventListener("click", (e) => {
      if (e.target.classList.contains("wt-cart__drawer__close")) {
        e.preventDefault();
        this.toggleDrawerClasses();
      }
    });

    document.addEventListener('cart-drawer:refresh', (e) => this.refreshCartDrawer(e))
  }

  renderContents(parsedState, isClosedCart = true) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    if (isClosedCart) {
      setTimeout(() => {
        this.toggleDrawerClasses();
        if (this.isOpen) {
          this.closeButton().focus();
        }
      });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  refreshCartDrawer(e){   
     console.log("🔥 refreshCartDrawer CALLED"); 
    const sectionsToRender = this.getSectionsToRender();
    fetch(`${window.Shopify.routes.root}?sections=${sectionsToRender[0].id},${sectionsToRender[1].id}`)
    .then(response => response.json())
    .then((response) => {
      const parsedState = {
        "sections": response
      }
      this.renderContents(parsedState, false);
      addonItems();
    })
    .catch(e => {
      console.log(e)
    })

  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawerSection);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
